import styled, { css } from 'styled-components';
import { ReactComponent as Space20 } from 'assets/svgs/space-20.svg';
import { ReactComponent as Space16 } from 'assets/svgs/space.svg';
import { AVAILABLE_SPACE_COLORS, Color } from 'components/colors';

type SpaceColor = [Color, ColorVariation];
type ColorVariation = 50 | 60 | 70;

const AVAILABLE_COLOR_VARIATIONS = 3;
/**
 * @function getColorVariations
 * @param spaceName
 * @description returns variation based on string length
 * @return 50 | 60 | 70
 */
const getColorVariations = (spaceName: string): ColorVariation => {
  switch (spaceName.length % AVAILABLE_COLOR_VARIATIONS) {
    case 1:
      return 60;
    case 2:
      return 70;
    case 0:
    default:
      return 50;
  }
};

/**
 * @function getSpaceColor
 * @param spaceName
 * @return [Color, ColorVariation]
 */
export const getSpaceColor = (spaceName = ''): SpaceColor => {
  return spaceName
    ? [
        AVAILABLE_SPACE_COLORS[
          spaceName.length % AVAILABLE_SPACE_COLORS.length
        ],
        getColorVariations(spaceName),
      ]
    : ['gray', 50];
};

/**
 * @function getColorVariable
 * @param name
 * @description returns colour variable Example: '--green-70'
 */
export const getColorVariable = (name: string): string => {
  const color = getSpaceColor(name);

  return `--${color[0]}-${color[1]}`;
};

const Icon = (icon) => styled(icon)`
  --fill-color: var(--gray-50);
  ${({ name }: { name: string }) => css`
    --fill-color: var(${getColorVariable(name)});
  `};
  color: var(--fill-color);
  fill: var(--fill-color);
`;

export const SpaceIcon = Icon(Space16);
export const SpaceIcon20 = Icon(Space20);
